import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';

import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

import { AppTheme } from '../styles/AppTheme';
import { BaseEntityPage } from '../common/components/BaseEntityPage';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { Helper } from '../common/helpers/Helper';
import { ReactDateRangeWrapper } from '../common/components/DateRangeComponent/ReactDateRangeWrapper';
import { AppConfig } from '../AppConfig';
import { AppHelper } from '../helpers/AppHelper';
import { dataItem } from '../data/data';

export class SurveySubmits extends BaseEntityPage {
  constructor(props) {
    super(props)
    this.noAdd = true
    this.pageTitle = 'Submits'
    this.surveyTitleById = {}
    this.surveySubsectionTitleById = {}
    this.export = {
      headers: {
        __index: 'Index', name: 'Name', phone: 'Phone', email: 'Email',
        dob: 'DOB', address: 'Address', responseId: 'Response ID', state: 'State',
        mandatorySectionIds: dataItem.surveyCatInfo.essential.title + ' Sections',
        baselineSectionIds: dataItem.surveyCatInfo.recommended.title + ' Sections',
        optionalSectionIds: dataItem.surveyCatInfo.optional.title + ' Sections',
        completedSectionIds: 'Completed Subsections',
        completedSectionTs: 'Completed SubSection Ts',
        preferedQSections: 'Prefered Surveys', referralCount: 'Referral Count',
        consentSignIP: 'Consent Sign IP', consentSignTs: 'Consent Sign Ts',
        consentSignType: 'Consent Sign Type',
        completedSubsectionsCount: 'Completed SubSections Count',
        preferredSectionsCount: 'Preferred Sections Count',
        preferredSubSectionsCount: 'Preferred SubSections Count',
      },
      format: 'xlsx'
    }
    this.quizId = AppConfig.quizId
    this.state.dateRangeOptions = {
      id: 'Today',
      startDate: moment().startOf('day'),
      endDate: moment()
    }
    this.breadCrumbs = [
      { title: 'Home', to: '/admin' },
      { title: 'Submits' },
    ]
    this.tableHeadersMap = {
      Index: (current) => {
        return <span className={css(Styles.spanValue)}>{current.__index + 1}</span>
      },
      User: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.email}</span>
            <br />
            <span className={css(Styles.spanValue)}>
              {(Helper.formatName(current) || 'UNKNOWN') + ' | Joined on ' + Helper.formatTimestamp(current.createdTs)}</span>
            <br />
            <span className={css(Styles.spanValue)}>
              {current.preferedQSections ? current.preferedQSections.length + ' Preferred Sections' : ''}
            </span>
            <br />
            <span className={css(Styles.spanValue)}>
              {this.subSectionCount(current.preferedQSections) + ' Preferred Sub Sections'}
            </span>
            <br />
            {current.responseId &&
              <span className={css(Styles.spanValue)}>RID | {current.responseId}</span>
            }
          </div>
        )
      },
      Progress: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>
              {current.completedSectionIds ? current.completedSectionIds.length + ' Sub Sections' : ''}
            </span>
            <br />
            <span className={css(Styles.spanValue)}>
              {current.completedSectionTs ? 'Latest on ' + Helper.formatDate(current.completedSectionTs) : ''}
            </span>
          </div>
        )
      },
      Consent: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>
              {current.consentSignIP || ''}
            </span>
            <br />
            <span className={css(Styles.spanValue)}>
              {current.consentSignTs ? 'Consent on ' + Helper.formatDate(current.consentSignTs) : ''}
            </span>
            <br />
            <div className={css(Styles.detailContainer)} >
              {current.dob &&
                <span className={css(Styles.spanValue)}>
                  DOB | {current.dob} {this.findAge(current)}
                </span>
              }
            </div>
            <div className={css(Styles.detailContainer)} >
              {current.consentGuardianName &&
                <span className={css(Styles.spanValue)}>
                  Guardian Name - {current.consentGuardianName}
                </span>
              }
            </div>
            <div className={css(Styles.detailContainer)} >
              {current.consentGuardianEmail &&
                <span className={css(Styles.spanValue)}>
                  Guardian Email - {current.consentGuardianEmail}
                </span>
              }
            </div>
          </div>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
  }

  findAge = (appUser) => {
    const age = AppHelper.calculateAgeBasedonUserCreatedTs(appUser)
    if (age < 13) {
      return '(CHILD)'
    } else if (age >= 13 && age < 18) {
      return '(MINOR)'
    }
  }

  fetchItems() {
    if (!this.state.dateRangeOptions) return
    const queryParams = {
      startModifiedTs: moment(this.state.dateRangeOptions.startDate).valueOf(),
      endModifiedTs: moment(this.state.dateRangeOptions.endDate).valueOf(),
      quizId: AppConfig.quizId
    }
    this.toFetch = [
      { method: 'GET', paths: ['miscs', 'user-submits'], queryParams: queryParams },
      {
        method: 'GET', endPoint: ApiHelper.makeUrlPath(['miscs', 'quiz-sections'],
          { quizId: AppConfig.quizId })
      },
    ]
    return super.fetchItems()
  }

  onDateRangeChange = (dateRangeOptions) => {
    this.setState({ dateRangeOptions }, () => {
      this.fetchItems()
    })
  }

  dateRangeComponent() {
    return (
      <ReactDateRangeWrapper key='dateTimeRangePicker'
        onDateRangeChange={this.onDateRangeChange}
        initialRange={this.state.dateRangeOptions}>
      </ReactDateRangeWrapper>
    )
  }

  onFetchSuccess(results) {
    this.generateSurveyDict(results[1])
    this.handleNextpage(results[0])
    this.setState({
      items: results[0].items,
      headerActionComponents: [this.dateRangeComponent()],
    })
  }

  onFetchNextSuccess(results) {
    this.handleNextpage(results[0])
    this.setState({
      items: this.state.items.concat(results[0].items),
    })
  }

  generateSurveyDict = (items) => {
    if (items && items.sections) {
      for (const item of items.sections) {
        const section = {
          title: item.title,
          subSectionCount: 0
        }
        this.surveyTitleById[item.id] = section
        if (!item.subsections) continue
        section.subSectionCount = item.subsections.length
        for (const ss of item.subsections) {
          this.surveySubsectionTitleById[ss.id] = {
            title: ss.title,
            parentTitle: item.title,
            baseline: item.baseline,
            parentId: ss.parentId
          }
        }
      }
    }
  }

  subSectionCount(sectionIds) {
    let count = 0
    sectionIds && sectionIds.forEach(i => {
      if(this.surveyTitleById[i]) {
        count += this.surveyTitleById[i].subSectionCount
      }
    })
    return count
  }

  exportRowItemValue(key, current) {
    switch (key) {
    case '__index':
      return current.__index + 1
    case 'name':
      return Helper.formatName(current)
    case 'address':
      return AppHelper.formatAddress(current)
    case 'mandatorySectionIds':
      return this.getSurveySubsectionNamefromIdGroupedBybaseline(current.completedSectionIds, 'MANDATORY')
    case 'baselineSectionIds':
      return this.getSurveySubsectionNamefromIdGroupedBybaseline(current.completedSectionIds, 'BASELINE')
    case 'optionalSectionIds':
      return this.getSurveySubsectionNamefromIdGroupedBybaseline(current.completedSectionIds, 'OPTIONAL')
    case 'completedSectionIds':
      return this.getSurveySubsectionNamefromIdGroupedBybaseline(current.completedSectionIds)
    case 'completedSectionTs':
      return Helper.formatTimestamp(current.completedSectionTs)
    case 'preferedQSections':
      return this.getSurveyNamefromId(current.preferedQSections)
    case 'consentSignTs':
      return Helper.formatTimestamp(current.consentSignTs)
    case 'completedSubsectionsCount':
      return current.completedSectionIds ? current.completedSectionIds.length : 0
    case 'preferredSectionsCount':
      return current.preferedQSections ? current.preferedQSections.length : 0
    case 'preferredSubSectionsCount':
      return this.subSectionCount(current.preferedQSections)
    default:
      return current[key]
    }
  }

  getSurveySubsectionNamefromId = (ids) => {
    const titles = []
    for (const id of ids) {
      if (!this.surveySubsectionTitleById[id]) continue
      titles.push(
        this.surveySubsectionTitleById[id].title + '(Survey: ' + this.surveySubsectionTitleById[id].parentTitle + ')'
      )
    }
    return AppHelper.arrToCsv(titles)
  }

  getSurveySubsectionNamefromIdGroupedBybaseline = (ids, baseline) => {
    const titles = []
    const sections = {}
    for (const id of ids) {
      if (!this.surveySubsectionTitleById[id] || (baseline && this.surveySubsectionTitleById[id].baseline !== baseline)) continue
      if(!sections[this.surveySubsectionTitleById[id].parentId]) {
        sections[this.surveySubsectionTitleById[id].parentId] = this.surveySubsectionTitleById[id].parentTitle + ' : ' + this.surveySubsectionTitleById[id].title
      } else {
        sections[this.surveySubsectionTitleById[id].parentId] = sections[this.surveySubsectionTitleById[id].parentId] + ', ' + this.surveySubsectionTitleById[id].title
      }
    }
    for(const s in sections) {
      titles.push(sections[s])
    }
    return AppHelper.arrToCsvWithNewline(titles)
  }

  getSurveyNamefromId = (ids) => {
    const titles = []
    if (ids) {
      for (const id of ids) {
        if (!this.surveyTitleById[id]) continue
        titles.push(this.surveyTitleById[id].title)
      }
    }
    return AppHelper.arrToCsv(titles)
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) {
      return ''
    }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onActions = (current) => {
    const actions = []
    return actions
  }
}

const Styles = StyleSheet.create({
  title: {
    color: 'black',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontSize: 24
  },
  detailContainer: {
    display: 'flex',
    alignItems: 'center'
  }
})



// WEBPACK FOOTER //
// ./src/screens/SurveySubmits.js